// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OL3U","rootNoMargin":"styles_rootNoMargin__3Y-t0"};